/* eslint-disable no-debugger */
import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as yup from 'yup'
import { colors, sizes } from '~/assets/styles/variables'
import { H4 } from '~/components/atoms/Heading'
import PageContainer from '~/components/atoms/PageContainer'
import { P3 } from '~/components/atoms/Paragraph'
import ActionBar from '~/components/molecules/ActionBar'
import FormControl from '~/components/molecules/FormControl'
import Wizard from '~/components/molecules/Wizard'
import PortalTemplate from '~/components/templates/PortalTemplate'
import { pageWidth } from '~/config/layout/pageWidth'

import setTitle from '~/config/title'
import { RadioButtonValuesInterface } from '~/models/interfaces/components/FormControl'

import { WizardInputInterface } from '~/models/interfaces/components/Wizard'
import { getNegotiationsTypesByCustomer } from '~/services/Negotiations'
import { RootState } from '~/store/reducers'
import RadioButtonContentContent from '~/components/molecules/RadioButtonContent'

interface NegotiationType {
  negotiationId: string | null
}

const containerPageWidth = pageWidth.medium
const { darkGray } = colors
const { size0, size24, size64 } = sizes

const wizardElements: WizardInputInterface[] = [
  {
    title: 'Seleção tipo de negociação',
    active: true,
  },
  {
    title: 'Seleção de contratos',
  },
  {
    title: 'Efetivação',
  },
  {
    title: 'Geração de boletos',
  },
]

const TypeNegotiation = () => {
  setTitle('Seleção de tipo de negociação - Quitação')

  const history = useHistory()
  const { auth: authSelector, userDataProcessing: userDataSelector } = useSelector(
    ({ auth, userDataProcessing }: RootState) => ({ auth, userDataProcessing })
  )

  const { user } = authSelector
  const { idEntryAutomation } = userDataSelector

  const [negotiations, setNegotiations] = useState<RadioButtonValuesInterface[]>([])

  const handleRedirect = (page: string) => history.push(page)
  const handleSubmit = ({ negotiationId }: NegotiationType) => {
    history.push(`quitacao/contratos/${negotiationId}`)
  }

  const validationSchema: yup.SchemaOf<NegotiationType> = yup.object({
    negotiationId: yup.string().required(''),
  })

  useEffect(() => {
    if (!user) return

    getNegotiationsTypesByCustomer(user.id).then((response) => {
      const newNegotiations: RadioButtonValuesInterface[] = response.map(({ id, name }) => ({
        id,
        label: (
          <RadioButtonContentContent
            title={name}
            subtitleAux="Condições especiais para quitar ou antecipar parcelas na"
          />
        ),
      }))
      setNegotiations(newNegotiations)
    })
  }, [idEntryAutomation, user])

  return (
    <PortalTemplate>
      <Wizard>{wizardElements}</Wizard>
      <PageContainer width={containerPageWidth}>
        {/* <CampaignBanner /> */}

        <>
          <H4 marginBottom={size24}>
            Para quitar ou antecipar suas parcelas, selecione uma das negociações disponíveis
            abaixo:
          </H4>

          <P3 color={darkGray} marginBottom={size64}>
            Ao selecionar um tipo de negociação e clicar para continuar, incluíremos de forma
            automática todos os contratos que podem ser quitados ou antecipados juntos.
          </P3>

          <Formik
            enableReinitialize
            initialValues={{ negotiationId: null }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            validateOnMount
          >
            {({ handleChange, isValid, values }) => (
              <Form>
                <FormControl
                  marginBottom={size0}
                  name="negotiationId"
                  onChange={handleChange}
                  showError={false}
                  textAlign="left"
                  type="radio"
                  value={values.negotiationId}
                  valuesRadio={negotiations}
                />

                <ActionBar
                  returnAction={() => handleRedirect('/menu-cliente')}
                  submitActive={isValid}
                  width={containerPageWidth}
                />
              </Form>
            )}
          </Formik>
        </>
      </PageContainer>
    </PortalTemplate>
  )
}

export default TypeNegotiation
